import { SupportedTpaAppDefIds } from '@wix/a11y-adapters';
import { A11Y_RULES_EXPERIMENTS } from '@wix/a11y-rules';
import { useErrorHandler, useExperiments, useHttpClient } from '@wix/fe-essentials/react';
import { useCallback } from 'react';
import { updateGiftCardProductAltText } from '../../api/new-infra-updates/update-gift-card-product-alt-text';
import { useSetGalleryItemsV2 } from './use-set-gallery-items-v2';
export const useTpaEntityDataHandlers = () => {
  const {
    updateGalleryItems: updateGalleryItemsV2
  } = useSetGalleryItemsV2();
  const httpClient = useHttpClient();
  const errorHandler = useErrorHandler();
  const {
    experiments
  } = useExperiments();
  const isGiftCardEnabled = experiments.enabled(A11Y_RULES_EXPERIMENTS.ENABLE_GIFT_CARD);
  const setTpaEntityData = useCallback(async (appDefId, data) => {
    switch (appDefId) {
      case SupportedTpaAppDefIds.PRO_GALLERY:
        await updateGalleryItemsV2(data);
        break;
      case SupportedTpaAppDefIds.GIFT_CARD:
        {
          // Defense-in-depth: the scan is already gated by the same spec, so
          // gift card items only exist when it is on. This guards the stale-scan
          // edge case (spec turned off while an old scan is still open). Fail
          // closed — a silent no-op here would be treated by the caller as a
          // successful fix and mark the item resolved without writing anything.
          if (!isGiftCardEnabled) {
            throw new Error('Gift card updates are disabled');
          }
          const result = await updateGiftCardProductAltText(httpClient, errorHandler, data);
          if (!result.success) {
            throw new Error(result.errorMessage ?? 'Failed to update gift card alt text');
          }
          break;
        }
      default:
        break;
    }
  }, [errorHandler, httpClient, isGiftCardEnabled, updateGalleryItemsV2]);
  return {
    setTpaEntityData
  };
};
//# sourceMappingURL=use-tpa-entity-data-handlers.js.map